import gql from "graphql-tag"

import {
  CartFields,
  CartUserErrorFields,
  CheckoutFields,
  CheckoutUserErrorsFields,
  CustomerFields,
  CustomerUserErrorsFields,
} from "./fragments"

// export const CreateCheckoutV1 = gql`
//   ${CheckoutFieldsV1}
//   ${CheckoutUserErrorsFields}
//   mutation CreateCheckout(
//     $lineItems: [CheckoutLineItemInput!]
//     $note: String!
//   ) {
//     checkoutCreate(input: { lineItems: $lineItems, note: $note }) {
//       checkout {
//         ...CheckoutFields
//       }
//       checkoutUserErrors {
//         ...CheckoutUserErrorsFields
//       }
//     }
//   }
// `

// add new item to cart (create checkout)

export const CreateCheckout = gql`
  ${CartFields}
  ${CartUserErrorFields}
  mutation cartCreate($input: CartInput!) {
    cartCreate(input: $input) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorFields
      }
    }
  }
`

// update existing checkout (add new item to cart)
export const UpdateCartLineCheckout = gql`
  ${CartFields}
  ${CartUserErrorFields}
  mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorFields
      }
    }
  }
`

// update existing checkout (update item in cart)
export const UpdateCartCheckout = gql`
  ${CartFields}
  ${CartUserErrorFields}
  mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorFields
      }
    }
  }
`

// remove item from checkout (remove item from cart)
export const RemoveCartCheckout = gql`
  ${CartFields}
  ${CartUserErrorFields}
  mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorFields
      }
    }
  }
`

// export const ApplyDiscount = gql`
//   ${CheckoutFields}
//   ${CheckoutUserErrorsFields}
//   mutation ApplyDiscount($checkoutId: ID!, $discountCode: String!) {
//     checkoutDiscountCodeApplyV2(
//       checkoutId: $checkoutId
//       discountCode: $discountCode
//     ) {
//       checkout {
//         ...CheckoutFields
//       }
//       checkoutUserErrors {
//         ...CheckoutUserErrorsFields
//       }
//     }
//   }
// `

export const ApplyDiscount = gql`
  ${CartFields}
  ${CartUserErrorFields}
  mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
      cart {
        ...CartFields
      }
      userErrors {
        ...CartUserErrorFields
      }
    }
  }
`

export const RemoveDiscount = gql`
  ${CheckoutFields}
  ${CheckoutUserErrorsFields}
  mutation RemoveDiscount($checkoutId: ID!) {
    checkoutDiscountCodeRemove(checkoutId: $checkoutId) {
      checkout {
        ...CheckoutFields
      }
      checkoutUserErrors {
        ...CheckoutUserErrorsFields
      }
    }
  }
`

export const CreateAccount = gql`
  ${CustomerFields}
  ${CustomerUserErrorsFields}
  mutation CreateCustomer($input: CustomerCreateInput!) {
    customerCreate(input: $input) {
      customer {
        ...CustomerFields
      }
      customerUserErrors {
        ...CustomerUserErrorsFields
      }
    }
  }
`

export const GetCustomerAccessToken = gql`
  mutation GetCustomerAccessToken($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
      userErrors {
        field
        message
      }
      customerAccessToken {
        accessToken
        expiresAt
      }
    }
  }
`

export const DeleteCustomerAccessToken = gql`
  mutation DeleteCustomerAccessToken($customerAccessToken: String!) {
    customerAccessTokenDelete(customerAccessToken: $customerAccessToken) {
      deletedAccessToken
      deletedCustomerAccessTokenId
      userErrors {
        field
        message
      }
    }
  }
`

export const AssociateCheckout = gql`
  ${CheckoutUserErrorsFields}
  mutation AssociateCheckout($checkoutId: ID!, $customerAccessToken: String!) {
    checkoutCustomerAssociateV2(
      checkoutId: $checkoutId
      customerAccessToken: $customerAccessToken
    ) {
      checkout {
        id
      }
      checkoutUserErrors {
        ...CheckoutUserErrorsFields
      }
      customer {
        id
      }
    }
  }
`

export const CustomerAddressCreate = gql`
  ${CustomerUserErrorsFields}
  mutation CustomerAddressCreate(
    $customerAccessToken: String!
    $address: MailingAddressInput!
  ) {
    customerAddressCreate(
      customerAccessToken: $customerAccessToken
      address: $address
    ) {
      customerAddress {
        id
      }
      customerUserErrors {
        ...CustomerUserErrorsFields
      }
    }
  }
`

export const CustomerAddressUpdate = gql`
  ${CustomerUserErrorsFields}
  mutation CustomerAddressUpdate(
    $customerAccessToken: String!
    $id: ID!
    $address: MailingAddressInput!
  ) {
    customerAddressUpdate(
      customerAccessToken: $customerAccessToken
      id: $id
      address: $address
    ) {
      customerAddress {
        id
      }
      customerUserErrors {
        ...CustomerUserErrorsFields
      }
    }
  }
`

export const CustomerAddressDelete = gql`
  ${CustomerUserErrorsFields}
  mutation CustomerAddressDelete($id: ID!, $customerAccessToken: String!) {
    customerAddressDelete(id: $id, customerAccessToken: $customerAccessToken) {
      customerUserErrors {
        ...CustomerUserErrorsFields
      }
      deletedCustomerAddressId
    }
  }
`

export const CustomerDefaultAddressUpdate = gql`
  ${CustomerUserErrorsFields}
  mutation CustomerDefaultAddressUpdate(
    $customerAccessToken: String!
    $addressId: ID!
  ) {
    customerDefaultAddressUpdate(
      customerAccessToken: $customerAccessToken
      addressId: $addressId
    ) {
      customer {
        id
      }
      customerUserErrors {
        ...CustomerUserErrorsFields
      }
    }
  }
`

export const ProductCreate = gql`
  mutation productCreate($input: ProductInput!, $media: [CreateMediaInput!]) {
    productCreate(input: $input, media: $media) {
      product {
        id
        title
      }
      userErrors {
        field
        message
      }
    }
  }
`

export const ProductUpdate = gql`
  mutation productUpdate($input: ProductInput!) {
    productUpdate(input: $input) {
      product {
        id
        title
      }
      userErrors {
        field
        message
      }
    }
  }
`

export const ProductVariantsBulkUpdate = gql`
  mutation productVariantsBulkUpdate(
    $productId: ID!
    $variants: [ProductVariantsBulkInput!]!
  ) {
    productVariantsBulkUpdate(productId: $productId, variants: $variants) {
      product {
        title
      }
      productVariants {
        title
      }
      userErrors {
        field
        message
      }
    }
  }
`
export const ProductDelete = gql`
  mutation productDelete($input: ProductDeleteInput!) {
    productDelete(input: $input) {
      deletedProductId
      userErrors {
        field
        message
      }
    }
  }
`

export const ProductAppendImages = gql`
  mutation productAppendImages($input: ProductAppendImagesInput!) {
    productAppendImages(input: $input) {
      product {
        id
      }
      userErrors {
        field
        message
      }
    }
  }
`

export const ProductMediaCreate = gql`
  mutation productCreateMedia($media: [CreateMediaInput!]!, $productId: ID!) {
    productCreateMedia(media: $media, productId: $productId) {
      product {
        id
      }
    }
  }
`
